import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
export const ProtectedRoute = () => {
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  const location = useLocation();
  // Show loading indicator while checking authentication
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center" data-id="element-42">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-brand-600" data-id="element-43"></div>
      </div>;
  }
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-44" />;
  }
  // Render the protected content
  return <Outlet data-id="element-45" />;
};